var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c("div", { staticClass: "row q-mb-sm" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c(
            "div",
            { staticClass: "q-display-1 text-secondary" },
            [
              _c("q-icon", {
                staticClass: "q-mb-sm",
                attrs: { name: "fas fa-list" }
              }),
              _vm._v(
                " " + _vm._s(_vm.$t(_vm.title_trainings)) + "\n            "
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "q-tabs",
        {
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "basic-data",
              label: _vm.$t("basic_data")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: { slot: "title", name: "modules", label: _vm.$t("modules") },
            slot: "title"
          }),
          _vm.hasGames
            ? _c("q-tab", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showTab,
                    expression: "showTab"
                  }
                ],
                attrs: { slot: "title", name: "games", label: _vm.$t("games") },
                slot: "title"
              })
            : _vm._e(),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: { slot: "title", name: "tests", label: _vm.$t("tests") },
            slot: "title"
          }),
          _vm.selected_client_params.group_training_use_evaluations
            ? _c("q-tab", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showTab,
                    expression: "showTab"
                  }
                ],
                attrs: {
                  slot: "title",
                  name: "reaction_tests",
                  label: _vm.$t("reaction_tests")
                },
                slot: "title"
              })
            : _vm._e(),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: {
              slot: "title",
              name: "support_material",
              label: _vm.$t("support_materials")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: {
              slot: "title",
              name: "configure_and_publish",
              label: _vm.$t("configure_and_publish")
            },
            slot: "title"
          }),
          _vm.useCommentsGroupTraining
            ? _c("q-tab", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showTab,
                    expression: "showTab"
                  }
                ],
                attrs: {
                  slot: "title",
                  name: "comments",
                  label: _vm.$t("comments")
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.hasForum
            ? _c("q-tab", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showTab,
                    expression: "showTab"
                  }
                ],
                attrs: {
                  slot: "title",
                  name: "discussions",
                  label: _vm.$t("discussions")
                },
                slot: "title"
              })
            : _vm._e(),
          _c(
            "q-tab-pane",
            { attrs: { name: "basic-data" } },
            [
              _c("basic-data", {
                attrs: {
                  managerTrainings: _vm.permissions.trainings_manage,
                  set_score: _vm.permissions.trainings_set_score
                }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "modules" } },
            [
              _c("modules", {
                attrs: { managerTrainings: _vm.permissions.trainings_manage }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "games" } },
            [
              _c("games", {
                attrs: { managerTrainings: _vm.permissions.trainings_manage }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "tests" } },
            [
              _c("tests", {
                attrs: { managerTrainings: _vm.permissions.trainings_manage }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "reaction_tests" } },
            [
              _c("reaction-tests", {
                attrs: { managerTrainings: _vm.permissions.trainings_manage }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "support_material" } },
            [
              _c("support-material", {
                attrs: { managerTrainings: _vm.permissions.trainings_manage }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "configure_and_publish" } },
            [
              _c("configure-and-publish", {
                attrs: { managerTrainings: _vm.permissions.trainings_manage },
                on: { duplicate: _vm.changeTab }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "comments" } },
            [_c("comments", { attrs: { origin: "training" } })],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "discussions" } },
            [_c("discussions")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }